import {objectFromEntries, range} from '@benchling/js-utils';

import {assert} from 'Asserts';
import {PipelineConfigJsonSpec} from 'pipelines/StepShapeUtils';
import {assertNever, JSONValue} from 'util/Types';

import {
  EnumUISchema,
  getFieldSettingsIfPresent,
  getFieldSettingsIfPresentV2,
  ShapeUISchema,
  ShapeUISchemaV2,
  StepConfigUISchema,
  StepConfigUISchemaV2,
} from '../StepConfigEditorTypes';

export default function jsonSpecToInitialValue(
  jsonSpec: PipelineConfigJsonSpec,
  uiSchema: StepConfigUISchema | StepConfigUISchemaV2
): JSONValue {
  if (jsonSpec.kind === 'string') {
    if (jsonSpec.value) {
      return jsonSpec.value;
    } else {
      return null;
    }
  }
  if (jsonSpec.kind === 'number') {
    return null;
  } else if (jsonSpec.kind === 'integer') {
    return null;
  } else if (jsonSpec.kind === 'boolean') {
    return null;
  } else if (jsonSpec.kind === 'columnReference') {
    return null;
  } else if (jsonSpec.kind === 'columnValue') {
    return null;
  } else if (jsonSpec.kind === 'tableReference') {
    return null;
  } else if (jsonSpec.kind === 'domain') {
    return null;
  } else if (jsonSpec.kind === 'anything') {
    return null;
  } else if (jsonSpec.kind === 'array') {
    // For array specs, default to `spec.minItems` objects if it's defined, or no items if it's undefined.
    return range(1, jsonSpec.minItems ?? 0).map(() => jsonSpecToInitialValue(jsonSpec.elementSpec, uiSchema));
  } else if (jsonSpec.kind === 'enum') {
    return (uiSchema?.hasOwnProperty('defaultValue') ?? false)
      ? ((uiSchema as EnumUISchema | undefined)?.defaultValue ?? null)
      : null;
  } else if (jsonSpec.kind === 'taggedUnion') {
    return null;
  } else if (jsonSpec.kind === 'shape') {
    return objectFromEntries(
      Object.entries(jsonSpec.fields).map(([fieldName, fieldSpec]) => {
        // Try V1 approach first, then fallback to V2 if no field settings found
        let fieldSettings: StepConfigUISchema | StepConfigUISchemaV2 = getFieldSettingsIfPresent(
          uiSchema as ShapeUISchema | undefined,
          fieldName
        );
        if (!fieldSettings) {
          fieldSettings = getFieldSettingsIfPresentV2(uiSchema as ShapeUISchemaV2 | undefined, fieldName);
        }

        return [fieldName, jsonSpecToInitialValue(fieldSpec, fieldSettings)];
      })
    );
  } else {
    assert(false, `Unexpected jsonSpec ${assertNever(jsonSpec)}`);
  }
}
